/* eslint-disable @nfq/no-magic-numbers */
import {spacing} from '@nfq/react-grid';

/**
 * Gets the padding value based on the file item size.
 *
 * @param size The size of the file item ('large' or 'small').
 * @returns The padding value in pixels (32 for large, 20 for small).
 */
export const getItemPadding = (size: 'large' | 'small') => (size === 'large' ? `${spacing(5)} ${spacing(4)}` : `${spacing(3)} ${spacing(4)}`);

/**
 * Gets the icon size based on the file item size.
 *
 * @param size The size of the file item ('large' or 'small').
 * @returns The icon size in pixels (24 for large, 20 for small).
 */
export const getIconSize = (size: 'large' | 'small') => (size === 'large' ? 24 : 20);